import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment } from "vue"
import _imports_0 from '../../assets/svgs/edit.svg'
import _imports_1 from '../../assets/svgs/action_plus.svg'
import _imports_2 from '../../assets/svgs/delete.svg'


const _hoisted_1 = { class: "min-h-screen bg-background" }
const _hoisted_2 = { class: "p-4 lg:container lg:py-6" }
const _hoisted_3 = { class: "flex flex-row w-full justify-between pb-4" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-6 w-6",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor",
  "stroke-width": "2"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    d: "M7 16l-4-4m0 0l4-4m-4 4h18"
  })
], -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-6 w-6",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor",
  "stroke-width": "2"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    d: "M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z"
  })
], -1)
const _hoisted_6 = {
  key: 1,
  class: "card-main"
}
const _hoisted_7 = {
  key: 1,
  class: "space-y-3 flex flex-col space-y-3"
}
const _hoisted_8 = { class: "flex flex-col lg:flex-row justify-between items-center w-full" }
const _hoisted_9 = { class: "flex flex-col lg:flex-row lg:space-x-3 md:text-center" }
const _hoisted_10 = { class: "font-semibold text-2xl md:mb-3" }
const _hoisted_11 = { class: "flex flex-row items-center space-x-1" }
const _hoisted_12 = {
  key: 0,
  class: "px-3 py-2 bg-gray-100 rounded-2xl"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500 pr-1" }, "ID", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-6 w-6 text-gray-400",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor",
  "stroke-width": "2"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    d: "M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z"
  })
], -1)
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-6 w-6 text-red-500",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor",
  "stroke-width": "2"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    d: "M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z"
  })
], -1)
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = ["disabled"]
const _hoisted_19 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-6 w-6 text-green-500",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor",
  "stroke-width": "2"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    d: "M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
  })
], -1)
const _hoisted_20 = [
  _hoisted_19
]
const _hoisted_21 = { class: "pl-3" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-6 w-6",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor",
  "stroke-width": "2"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    d: "M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
  })
], -1)
const _hoisted_23 = {
  key: 5,
  class: "ml-4"
}
const _hoisted_24 = /*#__PURE__*/_createElementVNode("span", { class: "border border-yellow-50 rounded-md bg-yellow-50 text-yellow-600 py-2 px-4 text-sm" }, "Archived", -1)
const _hoisted_25 = [
  _hoisted_24
]
const _hoisted_26 = { class: "flex lg:mt-0 mt-4 flex-row space-x-3" }
const _hoisted_27 = { class: "flex flex-row space-x-3 items-center" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("span", { class: "font-semibold pb-1" }, "Stages", -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  d: "M19 9l-7 7-7-7"
}, null, -1)
const _hoisted_30 = [
  _hoisted_29
]
const _hoisted_31 = {
  key: 3,
  class: "flex w-full flex-col lg:flex-row justify-between pt-4 mt-4 lg:mt-0 lg:space-x-4"
}
const _hoisted_32 = { class: "w-full lg:w-4/12 flex flex-col space-y-3" }
const _hoisted_33 = { class: "card-main w-full" }
const _hoisted_34 = { key: 0 }
const _hoisted_35 = { class: "flex flex-row justify-between" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("span", { class: "text-xl font-semibold" }, "Candidate evaluation", -1)
const _hoisted_37 = { class: "flex flex-col relative" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("circle", {
    cx: "12",
    cy: "7",
    r: "2",
    fill: "black"
  }),
  /*#__PURE__*/_createElementVNode("circle", {
    cx: "12",
    cy: "17",
    r: "2",
    fill: "black"
  })
], -1)
const _hoisted_39 = [
  _hoisted_38
]
const _hoisted_40 = {
  key: 0,
  class: "absolute border-gray-100 right-0 top-auto mt-5 w-60 rounded-xl shadow-2xl text-sm overflow-hidden z-20"
}
const _hoisted_41 = {
  class: "rounded-md bg-white shadow-xs w-full px-2 py-1",
  role: "menu",
  "aria-orientation": "vertical",
  "aria-labelledby": "options-menu"
}
const _hoisted_42 = { class: "flex flex-col mt-4" }
const _hoisted_43 = { class: "flex flex-row items-center" }
const _hoisted_44 = {
  key: 0,
  src: _imports_0
}
const _hoisted_45 = {
  key: 1,
  class: "text-purple-600",
  src: _imports_1,
  alt: ""
}
const _hoisted_46 = { class: "font-semibold ml-4" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row items-center" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_2 }),
  /*#__PURE__*/_createElementVNode("span", { class: "font-semibold ml-4" }, "Remove")
], -1)
const _hoisted_48 = [
  _hoisted_47
]
const _hoisted_49 = { class: "flex flex-row w-full justify-between pt-2 items-center" }
const _hoisted_50 = { class: "flex flex-col" }
const _hoisted_51 = /*#__PURE__*/_createElementVNode("span", { class: "text-xs text-gray-400" }, "Template title", -1)
const _hoisted_52 = {
  key: 0,
  class: "text-primary font-semibold"
}
const _hoisted_53 = {
  key: 1,
  class: "font-semibold"
}
const _hoisted_54 = { class: "card-main w-full" }
const _hoisted_55 = { class: "flex flex-row justify-between" }
const _hoisted_56 = /*#__PURE__*/_createElementVNode("span", { class: "text-xl font-semibold" }, "Code challenge", -1)
const _hoisted_57 = { class: "flex flex-col relative" }
const _hoisted_58 = /*#__PURE__*/_createElementVNode("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("circle", {
    cx: "12",
    cy: "7",
    r: "2",
    fill: "black"
  }),
  /*#__PURE__*/_createElementVNode("circle", {
    cx: "12",
    cy: "17",
    r: "2",
    fill: "black"
  })
], -1)
const _hoisted_59 = [
  _hoisted_58
]
const _hoisted_60 = {
  key: 0,
  class: "absolute border-gray-100 right-0 top-auto mt-5 w-60 rounded-xl shadow-2xl text-sm overflow-hidden z-20"
}
const _hoisted_61 = {
  class: "rounded-md bg-white shadow-xs w-full px-2 py-1",
  role: "menu",
  "aria-orientation": "vertical",
  "aria-labelledby": "options-menu"
}
const _hoisted_62 = { class: "flex flex-col mt-4" }
const _hoisted_63 = { class: "flex flex-row items-center" }
const _hoisted_64 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_65 = { class: "font-semibold ml-4" }
const _hoisted_66 = { class: "flex flex-row w-full justify-between pt-2 items-center" }
const _hoisted_67 = { class: "flex flex-col" }
const _hoisted_68 = /*#__PURE__*/_createElementVNode("span", { class: "text-xs text-gray-400" }, "Challenge title", -1)
const _hoisted_69 = { class: "text-xs text-primary" }
const _hoisted_70 = ["href"]
const _hoisted_71 = { class: "w-full card-main" }
const _hoisted_72 = { class: "flex flex-row w-full space-x-3 items-center justify-between pb-3" }
const _hoisted_73 = /*#__PURE__*/_createElementVNode("span", { class: "text-xl font-semibold" }, "Candidates", -1)
const _hoisted_74 = { class: "flex flex-row justify-end w-full pb-3 items-center" }
const _hoisted_75 = { class: "flex flex-row space-x-2 items-center" }
const _hoisted_76 = { class: "w-30" }
const _hoisted_77 = {
  key: 0,
  class: "bg-primary-light px-2 py-2 font-bold text-xs w-full rounded"
}
const _hoisted_78 = {
  class: "overflow-y-scroll",
  style: {"max-height":"700px"}
}
const _hoisted_79 = { class: "w-full lg:w-8/12 h-3/4 mt-6 lg:mt-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_Loading = _resolveComponent("Loading")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Link = _resolveComponent("Link")!
  const _component_Skeleton = _resolveComponent("Skeleton")!
  const _component_InputUniversalCopy = _resolveComponent("InputUniversalCopy")!
  const _component_ShowStages = _resolveComponent("ShowStages")!
  const _component_ErrorPage = _resolveComponent("ErrorPage")!
  const _component_SimpleSelect = _resolveComponent("SimpleSelect")!
  const _component_JobCandidateCard = _resolveComponent("JobCandidateCard")!
  const _component_JobMemberSection = _resolveComponent("JobMemberSection")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_AddCandidatesForm = _resolveComponent("AddCandidatesForm")!
  const _component_ReusableModal = _resolveComponent("ReusableModal")!
  const _component_AddCandidatesInJob = _resolveComponent("AddCandidatesInJob")!
  const _component_AddTemplateToJob = _resolveComponent("AddTemplateToJob")!
  const _component_AddChallengeToJob = _resolveComponent("AddChallengeToJob")!
  const _directive_click_away = _resolveDirective("click-away")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Header),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_ctx.loading)
          ? (_openBlock(), _createBlock(_component_Loading, {
              key: 0,
              active: _ctx.loading,
              "onUpdate:active": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.loading) = $event)),
              "can-cancel": false,
              loader: "spinner",
              color: "#8908F9",
              width: 128,
              height: 128,
              opacity: 0.5,
              "is-full-page": true
            }, null, 8, ["active", "opacity"]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_Button, {
            label: "Back",
            variant: "outlined",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.router?.push('/jobs')))
          }, {
            startIcon: _withCtx(() => [
              _hoisted_4
            ]),
            _: 1
          }),
          _createVNode(_component_Link, {
            to: `/edit-job/${_ctx.jobId}`,
            label: "Edit job",
            variant: "contained"
          }, {
            startIcon: _withCtx(() => [
              _hoisted_5
            ]),
            _: 1
          }, 8, ["to"])
        ]),
        (!_ctx.error)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              (_ctx.loading)
                ? (_openBlock(), _createBlock(_component_Skeleton, {
                    key: 0,
                    option: "card"
                  }))
                : _createCommentVNode("", true),
              (!_ctx.loading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.job?.title), 1),
                        _createElementVNode("div", _hoisted_11, [
                          (!_ctx.isEdit)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_12, [
                                _hoisted_13,
                                _createTextVNode(_toDisplayString(_ctx.job?.workable_id), 1)
                              ]))
                            : (_openBlock(), _createBlock(_component_InputUniversalCopy, {
                                key: 1,
                                modelValue: _ctx.input,
                                autocomplete: "off",
                                onOnPaste: _ctx.onPaste,
                                "onUpdate:modelValue": _ctx.updateValue,
                                onOnKeypress: _cache[2] || (_cache[2] = (e) => _ctx.onlyPaste(e)),
                                placeholder: "Paste a valid workable url"
                              }, null, 8, ["modelValue", "onOnPaste", "onUpdate:modelValue"])),
                          (!_ctx.isEdit)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 2,
                                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.setIsEdit(true))),
                                class: "rounded hover:bg-gray-100 disabled:cursor-not-allowed"
                              }, _hoisted_15))
                            : _createCommentVNode("", true),
                          (_ctx.isEdit)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 3,
                                onClick: _cache[4] || (_cache[4] = 
										() => {
											_ctx.setIsEdit(false);
											_ctx.setInput(_ctx.job?.workable_id);
										}
									)
                              }, _hoisted_17))
                            : _createCommentVNode("", true),
                          (_ctx.isEdit)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 4,
                                onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.updateId && _ctx.updateId(...args))),
                                disabled: _ctx.errUrl,
                                class: "disabled:opacity-40"
                              }, _hoisted_20, 8, _hoisted_18))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_21, [
                            _createVNode(_component_Button, {
                              onOnClick: _ctx.syncCandidates,
                              sizeLabel: "text-sm",
                              label: "Sync With Workable",
                              variant: "contained"
                            }, {
                              startIcon: _withCtx(() => [
                                _hoisted_22
                              ]),
                              _: 1
                            }, 8, ["onOnClick"])
                          ]),
                          (
										_ctx.job.job_status ===
											'on_hold_by_client' ||
										_ctx.job.job_status === 'completed' ||
										_ctx.job.job_status === 'changed_in_scope'
									)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_23, _hoisted_25))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_26, [
                        _createVNode(_component_Button, {
                          label: "Search candidates",
                          variant: "",
                          onOnClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$router.push('/candidates')))
                        }),
                        _createVNode(_component_Button, {
                          label: "View details",
                          variant: "",
                          onOnClick: _ctx.handleDetail
                        }, null, 8, ["onOnClick"]),
                        _createVNode(_component_Button, {
                          label: "Job activity",
                          variant: "",
                          onOnClick: _ctx.handleEvents
                        }, null, 8, ["onOnClick"])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_27, [
                      _hoisted_28,
                      _createElementVNode("button", {
                        class: "rounded hover:bg-gray-100",
                        onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.setExpand(!_ctx.expand)))
                      }, [
                        (_openBlock(), _createElementBlock("svg", {
                          class: _normalizeClass([_ctx.expand && 'transform -rotate-180', "h-5 w-5 text-gray-400"]),
                          xmlns: "http://www.w3.org/2000/svg",
                          fill: "none",
                          viewBox: "0 0 24 24",
                          stroke: "currentColor",
                          "stroke-width": "2"
                        }, _hoisted_30, 2))
                      ])
                    ]),
                    (_ctx.expand)
                      ? (_openBlock(), _createBlock(_component_ShowStages, {
                          key: 0,
                          stages: _ctx.job?.job_stages,
                          totalCandidates: _ctx.job?.number_candidates
                        }, null, 8, ["stages", "totalCandidates"]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        (_ctx.error)
          ? (_openBlock(), _createBlock(_component_ErrorPage, { key: 2 }))
          : _createCommentVNode("", true),
        (!_ctx.error)
          ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
              _createElementVNode("div", _hoisted_32, [
                _createElementVNode("div", _hoisted_33, [
                  (!_ctx.loadingTemplate)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                        _createElementVNode("div", _hoisted_35, [
                          _hoisted_36,
                          _createElementVNode("div", _hoisted_37, [
                            _createElementVNode("button", {
                              class: "p-1 hover:bg-gray-100 rounded-lg disabled:opacity-50 disabled:cursor-not-allowed",
                              onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.isMenuOpen = !_ctx.isMenuOpen))
                            }, _hoisted_39),
                            (_ctx.isMenuOpen)
                              ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_40, [
                                  _createElementVNode("div", _hoisted_41, [
                                    _createElementVNode("div", _hoisted_42, [
                                      _createElementVNode("button", {
                                        onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.updateEvaluation && _ctx.updateEvaluation(...args))),
                                        class: "rounded p-4 hover:bg-background"
                                      }, [
                                        _createElementVNode("div", _hoisted_43, [
                                          (
																_ctx.job
																	?.job_evaluation
																	?.title
															)
                                            ? (_openBlock(), _createElementBlock("img", _hoisted_44))
                                            : (_openBlock(), _createElementBlock("img", _hoisted_45)),
                                          _createElementVNode("span", _hoisted_46, _toDisplayString(_ctx.job
																	?.job_evaluation
																	?.title
																	? 'Update Evaluation'
																	: 'Add Evaluation'), 1)
                                        ])
                                      ]),
                                      (
														_ctx.job?.job_evaluation?.id
													)
                                        ? (_openBlock(), _createElementBlock("button", {
                                            key: 0,
                                            onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.removeEvaluation && _ctx.removeEvaluation(...args))),
                                            class: "rounded p-4 hover:bg-background"
                                          }, _hoisted_48))
                                        : _createCommentVNode("", true)
                                    ])
                                  ])
                                ])), [
                                  [_directive_click_away, _ctx.closeMenu]
                                ])
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_49, [
                          _createElementVNode("div", _hoisted_50, [
                            _hoisted_51,
                            (_ctx.job?.job_evaluation?.title)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_52, _toDisplayString(_ctx.job?.job_evaluation?.title), 1))
                              : (_openBlock(), _createElementBlock("span", _hoisted_53, " Unassigned template "))
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.loadingTemplate)
                    ? (_openBlock(), _createBlock(_component_Skeleton, {
                        key: 1,
                        option: "card"
                      }))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_54, [
                  _createElementVNode("div", _hoisted_55, [
                    _hoisted_56,
                    _createElementVNode("div", _hoisted_57, [
                      _createElementVNode("button", {
                        class: "p-1 hover:bg-gray-100 rounded-lg disabled:opacity-50 disabled:cursor-not-allowed",
                        onClick: _cache[11] || (_cache[11] = ($event: any) => (
										_ctx.isMenuOpenChallenge =
											!_ctx.isMenuOpenChallenge
									))
                      }, _hoisted_59),
                      (_ctx.isMenuOpenChallenge)
                        ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_60, [
                            _createElementVNode("div", _hoisted_61, [
                              _createElementVNode("div", _hoisted_62, [
                                _createElementVNode("button", {
                                  onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.updateChallenge && _ctx.updateChallenge(...args))),
                                  class: "rounded p-4 hover:bg-background"
                                }, [
                                  _createElementVNode("div", _hoisted_63, [
                                    _hoisted_64,
                                    _createElementVNode("span", _hoisted_65, _toDisplayString(_ctx.job?.job_challenge
																?.id
																? 'Update challenge'
																: 'Add challenge'), 1)
                                  ])
                                ])
                              ])
                            ])
                          ])), [
                            [_directive_click_away, _ctx.closeMenuChallenge]
                          ])
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_66, [
                    _createElementVNode("div", _hoisted_67, [
                      _hoisted_68,
                      _createElementVNode("span", {
                        class: _normalizeClass(["font-semibold", [
										_ctx.job?.job_challenge?.title
											? 'text-primary'
											: '',
									]])
                      }, _toDisplayString(_ctx.job?.job_challenge?.title
											? _ctx.job?.job_challenge?.title
											: 'Unassigned code challenge'), 3),
                      _createElementVNode("span", _hoisted_69, [
                        _createElementVNode("a", {
                          href: 
											_ctx.job?.job_challenge?.challenge_url
										,
                          target: "_blank"
                        }, _toDisplayString(_ctx.job?.job_challenge?.challenge_url
												? _ctx.job?.job_challenge
														?.challenge_url
												: 'no specified'), 9, _hoisted_70)
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_71, [
                  _createElementVNode("div", _hoisted_72, [
                    _hoisted_73,
                    _createVNode(_component_Button, {
                      variant: "outlined",
                      labelSize: "text-xs",
                      label: "Add candidates",
                      onClick: _cache[13] || (_cache[13] = ($event: any) => (
									_ctx.$router.push(`/create-candidate/${_ctx.jobId}`)
								))
                    })
                  ]),
                  _createElementVNode("div", _hoisted_74, [
                    _createElementVNode("div", _hoisted_75, [
                      _createElementVNode("div", _hoisted_76, [
                        _createVNode(_component_SimpleSelect, {
                          modelValue: _ctx.stage,
                          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.stage) = $event)),
                          className: "text-xs",
                          label: "Filter by stages",
                          options: _ctx.selectStages
                        }, null, 8, ["modelValue", "options"])
                      ]),
                      _createElementVNode("button", {
                        onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.stage = '')),
                        class: "hover:text-primary-dark text-xs hover:bg-gray-100 text-primary"
                      }, " See all ")
                    ])
                  ]),
                  (_ctx.candidates && _ctx.candidates.length <= 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_77, " No candidates assigned in this stage "))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_78, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.candidates &&
								_ctx.candidates.length > 0 &&
								_ctx.candidates, (item, index) => {
                      return (_openBlock(), _createBlock(_component_JobCandidateCard, {
                        key: `card-candidate-${index + 1}`,
                        selected: _ctx.selected,
                        candidate: item,
                        onClickCard: ($event: any) => (_ctx.handleCandidateClick(item.id))
                      }, null, 8, ["selected", "candidate", "onClickCard"]))
                    }), 128))
                  ])
                ]),
                _createVNode(_component_JobMemberSection, { jobId: _ctx.jobId }, null, 8, ["jobId"])
              ]),
              _createElementVNode("div", _hoisted_79, [
                _createVNode(_component_router_view)
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createVNode(_component_ReusableModal, {
        show: _ctx.showForm,
        onClose: _ctx.closeInForm
      }, {
        default: _withCtx(() => [
          _createVNode(_component_AddCandidatesForm, {
            ref: "formRef",
            onCloseModal: _ctx.closeInForm,
            onGetCandidates: _ctx.getFromForm
          }, null, 8, ["onCloseModal", "onGetCandidates"])
        ]),
        _: 1
      }, 8, ["show", "onClose"]),
      _createVNode(_component_ReusableModal, {
        show: _ctx.showSearch,
        onClose: _cache[16] || (_cache[16] = ($event: any) => (_ctx.setShowSearch(false))),
        size: "w-1/2 bg-background min-h-screen"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_AddCandidatesInJob, { onGetCandidates: _ctx.getFromForm }, null, 8, ["onGetCandidates"])
        ]),
        _: 1
      }, 8, ["show"]),
      _createVNode(_component_ReusableModal, {
        show: _ctx.showModal,
        onClose: _cache[18] || (_cache[18] = ($event: any) => (_ctx.setShowModal(false))),
        size: "w-1/3 bg-background min-h-screen"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_AddTemplateToJob, {
            id: _ctx.jobId,
            onReload: _ctx.updateJobInfo,
            onClose: _cache[17] || (_cache[17] = ($event: any) => (_ctx.setShowModal(false)))
          }, null, 8, ["id", "onReload"])
        ]),
        _: 1
      }, 8, ["show"]),
      _createVNode(_component_ReusableModal, {
        show: _ctx.showModalChallenge,
        onClose: _cache[20] || (_cache[20] = ($event: any) => (_ctx.setShowModalChallenge(false))),
        size: "w-1/3"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_AddChallengeToJob, {
            id: _ctx.jobId,
            onReload: _ctx.updateJobInfo,
            onClose: _cache[19] || (_cache[19] = ($event: any) => (_ctx.setShowModalChallenge(false)))
          }, null, 8, ["id", "onReload"])
        ]),
        _: 1
      }, 8, ["show"])
    ])
  ], 64))
}